import {en} from "./en";
import {it} from "./it";
import {addAppLocale} from "@kopjra/uikit";

addAppLocale(en, "en");
addAppLocale(it, "it");